import styled from 'styled-components';

export const Wrapper = styled.div`
    border-radius: 48px;
    transition: background-color 0.2s ease-in-out;

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }
`;
